/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_LIGHT_PURPLE } from '../styles/colors/colors';
import { alpha } from '@mui/system';
export var fillIcon = /*#__PURE__*/React.createElement("svg", {
  role: "none",
  name: "fillIcon",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.7464 5.45612C12.7961 4.38545 14.5938 5.34728 14.2855 6.8146L13.616 10.0018H19.0007C20.5553 10.0018 21.5155 11.6978 20.7157 13.0308L17.7157 18.0308C17.3543 18.6332 16.7032 19.0018 16.0007 19.0018H8.5C8.22386 19.0018 8 18.778 8 18.5018V10.5018C8 10.3709 8.05133 10.2453 8.14296 10.1518L11.7464 5.45612ZM4 10.002C3.44772 10.002 3 10.4497 3 11.002V18.002C3 18.5542 3.44772 19.002 4 19.002H6C6.55228 19.002 7 18.5542 7 18.002V11.002C7 10.4497 6.55228 10.002 6 10.002H4Z",
  fill: PROMETHEAN_PURPLE_GRAPE
}));
export var emptyIcon = /*#__PURE__*/React.createElement("svg", {
  role: "none",
  name: "emptyIcon",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.2855 6.8146C14.5938 5.34728 12.7961 4.38545 11.7464 5.45612L7.29021 10.0016H4C3.44772 10.0016 3 10.4493 3 11.0016V18.0016C3 18.5539 3.44772 19.0016 4 19.0016H7.48463C7.48973 19.0017 7.49486 19.0018 7.5 19.0018H16.0007C16.7032 19.0018 17.3543 18.6332 17.7157 18.0308L20.7157 13.0308C21.5155 11.6978 20.5553 10.0018 19.0007 10.0018H13.616L14.2855 6.8146ZM12.4605 6.15618C12.8104 5.79929 13.4096 6.11989 13.3069 6.60901L12.5107 10.399C12.4797 10.5464 12.5169 10.7 12.6118 10.8169C12.7067 10.9339 12.8494 11.0018 13 11.0018H19.0007C19.778 11.0018 20.2581 11.8498 19.8582 12.5163L16.8582 17.5163C16.6775 17.8175 16.352 18.0018 16.0007 18.0018H8V10.706L12.4605 6.15618ZM7 18.0016V11.0016H4V18.0016H7Z",
  fill: PROMETHEAN_PURPLE_GRAPE
}));
export var hoverIcon = /*#__PURE__*/React.createElement("svg", {
  role: "none",
  name: "hoverIcon",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.7464 5.45612C12.7961 4.38545 14.5938 5.34728 14.2855 6.8146L13.616 10.0018H19.0007C20.5553 10.0018 21.5155 11.6978 20.7157 13.0308L17.7157 18.0308C17.3543 18.6332 16.7032 19.0018 16.0007 19.0018H8.5C8.22386 19.0018 8 18.778 8 18.5018V10.5018C8 10.3709 8.05133 10.2453 8.14296 10.1518L11.7464 5.45612ZM4 10.002C3.44772 10.002 3 10.4497 3 11.002V18.002C3 18.5542 3.44772 19.002 4 19.002H6C6.55228 19.002 7 18.5542 7 18.002V11.002C7 10.4497 6.55228 10.002 6 10.002H4Z",
  fill: alpha(PROMETHEAN_LIGHT_PURPLE, 0.4)
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.2855 6.8146C14.5938 5.34728 12.7961 4.38545 11.7464 5.45612L7.29021 10.0016H4C3.44772 10.0016 3 10.4493 3 11.0016V18.0016C3 18.5539 3.44772 19.0016 4 19.0016H7.48463C7.48973 19.0017 7.49486 19.0018 7.5 19.0018H16.0007C16.7032 19.0018 17.3543 18.6332 17.7157 18.0308L20.7157 13.0308C21.5155 11.6978 20.5553 10.0018 19.0007 10.0018H13.616L14.2855 6.8146ZM12.4605 6.15618C12.8104 5.79929 13.4096 6.11989 13.3069 6.60901L12.5107 10.399C12.4797 10.5464 12.5169 10.7 12.6118 10.8169C12.7067 10.9339 12.8494 11.0018 13 11.0018H19.0007C19.778 11.0018 20.2581 11.8498 19.8582 12.5163L16.8582 17.5163C16.6775 17.8175 16.352 18.0018 16.0007 18.0018H8V10.706L12.4605 6.15618ZM7 18.0016V11.0016H4V18.0016H7Z",
  fill: PROMETHEAN_PURPLE_GRAPE
}));